<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <OrdersToolbarInternal
          v-if="showInternalToolbar"
          :order-id-pre-filter="orderId"
          @physician-selected="selectedPhysician = $event"
        />
        <OrdersToolbar v-if="showOrdersGrid" />
        <OrdersGrid
          v-if="showOrdersGrid"
          :order-id-pre-filter="orderId || ''"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts" setup>
import { computed, ref, onBeforeMount, onMounted } from "vue";
import OrdersToolbarInternal from "@/components/orders/OrdersToolbarInternal.vue";
import OrdersToolbar from "@/components/orders/OrdersToolbar.vue";
import OrdersGrid from "@/components/orders/OrdersGrid.vue";
import { useRouter} from 'vue-router';
import {Physician} from "@/entities/physician";
import { useOrdersStore } from "@/stores/orders";
import { useOrdersGridVisibility } from '@/composables/useOrdersGridVisibility';

const router = useRouter();

const selectedPhysician = ref<Physician | null>(null);
const ordersStore = useOrdersStore();
const { showOrdersGrid, showInternalToolbar } = useOrdersGridVisibility();

const orderId = computed(() => {
  const id = ordersStore.searchOrderId

  if (!id) return ''

  return id
})

onBeforeMount(() => {
  if (orderId.value) {
    router.replace('/MyOrders');
  }
});

onMounted(() => {
  ordersStore.resetOrder();
  ordersStore.clearOrderPatient();
});
</script>
